import type { ReactNode } from "react";

import {
  FaintFill,
  Illustration,
  Outline,
  PageFill,
  StrongFill,
} from "./illustration";

interface Props {
  className?: string;
  children: ReactNode;
}

const WINDOW =
  "M8 2H104A6 6 0 0 1 110 8V76A6 6 0 0 1 104 82H8A6 6 0 0 1 2 76V8A6 6 0 0 1 8 2Z";

// A browser window, with whatever it shows drawn over its content area.
export function BrowserWindowIllustration({ className, children }: Props) {
  return (
    <Illustration width={112} height={84} className={className}>
      <PageFill d={WINDOW} />
      <FaintFill d={WINDOW} />
      <StrongFill d="M8 2H104A6 6 0 0 1 110 8V18H2V8A6 6 0 0 1 8 2Z" />
      <Outline d={`${WINDOW}M2 18H110`} />
      <path d="M9.3 10A1.7 1.7 0 1 1 12.7 10A1.7 1.7 0 1 1 9.3 10ZM16.3 10A1.7 1.7 0 1 1 19.7 10A1.7 1.7 0 1 1 16.3 10ZM23.3 10A1.7 1.7 0 1 1 26.7 10A1.7 1.7 0 1 1 23.3 10Z" />
      {children}
    </Illustration>
  );
}
